module.exports = __webpack_public_path__ + "media/images/sumi_mark-955d6bfd13753db74aa8c9a7543997c2.png";